export enum AllocationViewProfileRenderItems {
  Time = 'time',
  TruckStatus = 'truckStatus',
  TruckPlate = 'truckPlate',
  CarrierName = 'carrierName',
  CarrierId = 'carrierId',
  FreeTextCarrierName = 'freeTextCarrierName',
  Parties = 'parties',
  Dock = 'dock',
  LoadNumber = 'loadNumber',
  LoadProgress = 'loadProgress',
  LoadStatus = 'loadStatus',
  NumberOfHU = 'numberOfHU',
  RuleName = 'ruleName',
  UliStatus = 'uliStatus',
  Compartment = 'compartment',
  Uli = 'uli',
  AttachmentNeedsAttention = 'attachmentNeedsAttention',
  TruckArrival = 'truckArrival',
  DocumentNumbers = 'documentNumbers',
  ToNumbers = 'toNumbers',
  DockTime = 'dockTime',
}

export enum AllocationViewLocalRenderItems {
  Action = 'action',
}

const ALLOCATION_VIEW_TABLE_COLUMNS: AllocationViewProfileRenderItems[] = [
  AllocationViewProfileRenderItems.Time,
  AllocationViewProfileRenderItems.TruckStatus,
  AllocationViewProfileRenderItems.TruckPlate,
  AllocationViewProfileRenderItems.NumberOfHU,
  AllocationViewProfileRenderItems.RuleName,
  AllocationViewProfileRenderItems.CarrierId,
  AllocationViewProfileRenderItems.CarrierName,
  AllocationViewProfileRenderItems.FreeTextCarrierName,
  AllocationViewProfileRenderItems.Parties,
  AllocationViewProfileRenderItems.Dock,
  AllocationViewProfileRenderItems.LoadNumber,
  AllocationViewProfileRenderItems.LoadProgress,
  AllocationViewProfileRenderItems.LoadStatus,
  AllocationViewProfileRenderItems.UliStatus,
  AllocationViewProfileRenderItems.Compartment,
  AllocationViewProfileRenderItems.Uli,
  AllocationViewProfileRenderItems.AttachmentNeedsAttention,
  AllocationViewProfileRenderItems.TruckArrival,
  AllocationViewProfileRenderItems.DocumentNumbers,
  AllocationViewProfileRenderItems.ToNumbers,
  AllocationViewProfileRenderItems.DockTime,
];

export type AllocationViewTableColumnsType = Uncapitalize<
  keyof typeof AllocationViewProfileRenderItems | keyof typeof AllocationViewLocalRenderItems
>;

export const ALLOCATION_VIEW_LIST_ALL_RENDER_ITEMS: AllocationViewProfileRenderItems[] = ALLOCATION_VIEW_TABLE_COLUMNS;

export const ALLOCATION_VIEW_LIST_OPTIONAL_COLUMNS: AllocationViewProfileRenderItems[] = ALLOCATION_VIEW_TABLE_COLUMNS;

export const ALLOCATION_VIEW_LIST_REQUIRED_COLUMNS: AllocationViewTableColumnsType[] = [
  AllocationViewLocalRenderItems.Action,
];

export const ALLOCATION_VIEW_CALENDAR_ALL_RENDER_ITEMS: AllocationViewProfileRenderItems[] = [
  AllocationViewProfileRenderItems.CarrierName,
  AllocationViewProfileRenderItems.Time,
  AllocationViewProfileRenderItems.TruckPlate,
  AllocationViewProfileRenderItems.TruckStatus,
  AllocationViewProfileRenderItems.CarrierId,
  AllocationViewProfileRenderItems.FreeTextCarrierName,
  AllocationViewProfileRenderItems.LoadNumber,
  AllocationViewProfileRenderItems.Parties,
  AllocationViewProfileRenderItems.Uli,
  AllocationViewProfileRenderItems.NumberOfHU,
  AllocationViewProfileRenderItems.RuleName,
];

export const ALLOCATION_VIEW_CALENDAR_DEFAULT_RENDER_ITEMS: AllocationViewProfileRenderItems[] = [
  AllocationViewProfileRenderItems.CarrierName,
  AllocationViewProfileRenderItems.Time,
  AllocationViewProfileRenderItems.TruckPlate,
  AllocationViewProfileRenderItems.TruckStatus,
];
